export default __webpack_public_path__ + "static/media/expand.0df6bec8.svg";